// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d4aba7ab","885":"1186d0d3"}[chunkId] + ".chunk.js";
};